module.exports = __webpack_public_path__ + "img/Kalosoma-G.c366a2f7.png";